// export const API_HOST = "http://localhost:3001/api/v1/"; // --legacy-peer-deps
export const API_HOST = "https://annotation.toothlens.com/api/v1/";
export const CAVITY_IMG_URL =
    "https://toothlens-image-store.s3.ca-central-1.amazonaws.com/";
export const TARTAR_IMG_URL =
    "https://toothlens-image-store.s3.ca-central-1.amazonaws.com/";

export const BASE_IMAGE_URL = "https://toothlens-image-store.s3.ca-central-1.amazonaws.com";